import React, { useState } from 'react';
import styled from 'styled-components';
import { IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Row } from 'spw-shared/globalComponents';

const icons = [
  [
    'individual-workspaces-icon',
    'individual-workspaces-icon-1',
    'individual-workspaces-icon-2',
    'individual-workspaces-icon-3',
    'meeting-spaces-icon',
    'meeting-spaces-icon-1',
    'meeting-spaces-icon-2',
  ],
  [
    'meeting-spaces-icon-3',
    'amenity-spaces-icon',
    'amenity-spaces-icon-1',
    'amenity-spaces-icon-2',
    'support-spaces-icon',
    'support-spaces-icon-1',
    'support-spaces-icon-2',
  ],
];

const CarouselButton = styled(IconButton)`
  &:hover {
    background-color: #eeeeee;
  }
`;

export const ColorIcon = styled.div`
  && {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    background-color: ${(props) => props.color} !important;
    margin-right: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:last-of-type {
      margin-right: 0;
    }
    span {
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 8px;
      /* identical to box height, or 150% */

      text-align: center;
      text-transform: uppercase;

      /* Base/White */
      color: white;
    }
  }
`;

interface SpaceCategoryIconPickerProps {
  onIconSelected: (icon: any) => void;
  selectedIconColor: string;
  selectedIcon: string;
  currentIcon: string;
  defaultIcon: string;
  selectedIcons: string[];
}

const SpaceTypeCategoryIconPicker: React.FC<SpaceCategoryIconPickerProps> = ({
  onIconSelected,
  selectedIcon,
  currentIcon,
  defaultIcon,
  selectedIcons,
  selectedIconColor,
}) => {
  // This is used to determine whether we want to default to the first page
  // or the second page of icons
  const [rowIndex, setRowIndex] = useState(
    icons[1].includes(defaultIcon) ? 1 : 0
  );

  const otherSelectedIcons = selectedIcons.filter(
    (icon) =>
      icon !== selectedIcon && icon !== defaultIcon && icon !== currentIcon
  );
  return (
    <Row style={{ marginTop: '10px' }}>
      <CarouselButton
        aria-label="left"
        disabled={rowIndex === 0}
        onClick={() => setRowIndex(0)}
        edge="start"
      >
        <ChevronLeftIcon />
      </CarouselButton>
      <div
        style={{
          display: 'flex',
          flex: '1 1 auto',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icons[rowIndex].map((icon: string) => {
          const isSelected = icon === selectedIcon;
          const isDefault = icon === defaultIcon;
          const isOtherSelected = otherSelectedIcons.includes(icon);
          const isDisabled = !isSelected && !isDefault && isOtherSelected;
          let iconColor = '#707070';
          if (isSelected) {
            iconColor = selectedIconColor;
          } else if (isDisabled) {
            iconColor = '#DFDFDF';
          }
          const iconUrl = isDisabled ? `${icon}-grey` : icon;
          return (
            <ColorIcon
              key={icon}
              color={iconColor}
              style={isDisabled ? { cursor: 'default' } : null}
              onClick={() => (isDisabled ? null : onIconSelected(icon))}
            >
              {' '}
              <img src={`/images/${iconUrl}.svg`} alt="icon" />
            </ColorIcon>
          );
        })}
      </div>
      <CarouselButton
        aria-label="right"
        disabled={rowIndex === 1}
        onClick={() => setRowIndex(1)}
        edge="end"
      >
        <ChevronRightIcon />
      </CarouselButton>
    </Row>
  );
};

export default SpaceTypeCategoryIconPicker;
